// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3dRx_","upload":"Small_upload__3BzK3","imageWrap":"Small_imageWrap__1DWZ6","removeBtn":"Small_removeBtn___c01K"};